//var stripe = Stripe('pk_test_51JefJECov4rEieoXOav7BaVoipjTxKjtNSn3y25C9hXhU2NgC2w7nhGFOImKwZuHYOlzLzZLEe9NBBHfauwkb80i00ifUlrhr8');
let stripe = Stripe('pk_live_51JefJECov4rEieoXyidcPaNEyCmLlOMf4CW99bTPvSKZBQSzKwIDP9btph5qqGwFZbDHDiupZV9Yz047dGvTCha600v9FkMJce');

let cardElmComplete = false;
let addressElmcomplete = false;

var elements = stripe.elements();

var cardElement = elements.create('card');
const submissionErrors = document.getElementById('ballot-entry-errors');

cardElement.mount('#card-element');

const addressElement = elements.create("address", {
  mode: 'shipping',
  allowedCountries: ['AU'],
  blockPoBox: true,
  fields: {
    phone: 'always',
  },
  validation: {
    phone: {
      required: 'always',
    },
  },
});

addressElement.mount('#address-element');

var stripeAuBallotForm = document.getElementById('stripe-ballot-au-payment-form');

cardElement.on('change', function(event) {
  if (event.complete) {
    cardElmComplete = true;
  } else if (event.error) {
    // show validation to customer
  }
});

const dobDay = document.querySelector('#stripe-ballot-au-payment-form .ballot-dob-day');
const dobMonth = document.querySelector('#stripe-ballot-au-payment-form .ballot-dob-month');
const dobYear = document.querySelector('#stripe-ballot-au-payment-form .ballot-dob-year');
const customerEmail = document.getElementById('ballotAuEmail');

dobDay.addEventListener("keyup", function(){
  if (dobDay.value.length == 2) {
    dobMonth.focus();
  }
});

dobMonth.addEventListener("keyup", function(){
  if (dobMonth.value.length == 2) {
    dobYear.focus();
  }
});

dobYear.addEventListener("keyup", function(){
  if (dobYear.value.length == 4) {
    customerEmail.focus();
  }
});

let shippingPostCode = '';

addressElement.on('change', function(event) {
  if (event.complete) {
    addressElmcomplete = true;
    const address = event.value.address;
    shippingPostCode = address.postal_code;
  } else if (event.error) {
    // show validation to customer
  }
});

stripeAuBallotForm.addEventListener('submit', async function(event) {
    event.preventDefault();
    submissionErrors.textContent = '';
    
    let submitBtn = document.getElementById('ballotAuSubmit');
    submitBtn.disabled = true;
    
    let fName = document.getElementById('ballotAuFName').value.trim();
    let lName = document.getElementById('ballotAuLName').value.trim();
    let shoeSize = document.getElementById('ballotAuShoeSize').value.trim();
    let email = document.getElementById('ballotAuEmail').value.trim();
    
    const validationResult = validateRequiredFields(stripeAuBallotForm);
    if (validationResult == false) {
      submitBtn.disabled = false;
      return false;
    }
    
    const validateDobResult = validateDobField();
    if (validateDobResult === false) {
      submitBtn.disabled = false;
      return false;
    }
    
    let formData = getFormData(event.target.elements);
    
    // if (fName == '' || lName == '' || email == '') {
    //   submitBtn.disabled = false;
    //   return false;
    // }
    
    let fullName = fName + ' ' + lName;

    let addressElement = elements.getElement('address');
    let shippingAddress = {};

    try {
      
        addressElement.getValue().then(function(result) {
          if (result.complete) {
            shippingAddress.name = result.value.name;
            shippingAddress.line1 = result.value.address.line1;
            shippingAddress.line2 = result.value.address.line2;
            shippingAddress.city = result.value.address.city;
            shippingAddress.postal_code = result.value.address.postal_code;
            shippingAddress.state = result.value.address.state;
            shippingAddress.country = result.value.address.country;
            shippingAddress.phone = result.value.phone;
          } else {
            // address not completed
            addressElmcomplete = false;
            submitBtn.disabled = false;
            return false;
          }
        });
    
        if (addressElmcomplete === false) {
          return false;
        }
        
        // Set the zipcode for DotDigital from Stripe address
        formData['field--zipcode-text'] = shippingPostCode;
      
       
        // >>> Create a payment method - this will be attached to a customer
        const paymentMethodResult = await createPaymentMethod(fullName,email);
          
        if (paymentMethodResult.success === false) {
            //console.log('error creating payment method', paymentMethodResult.message);
            submissionErrors.textContent = paymentMethodResult.message;
            submitBtn.disabled = false;
            return false;
        } 

        const paymentMethodId = paymentMethodResult.paymentMethodId;
        // <<< end payment method
        
        // >>> Create a customer - and attach the payment method
        let metaData = getMetaDataForStripe();
    
        const customerResult = await createCustomer(fullName,email,shippingAddress,metaData,paymentMethodId);
        
        if (customerResult.success === false) {
            //console.log('error creating customer',customerResult.message);
            submissionErrors.textContent = customerResult.message;
            submitBtn.disabled = false;
            return false;
        }
        
        const customerId = customerResult.customerId;
        // <<< end create customer 
         
        // >>> Create and authenticate the setup intent
        const setupIntent = await createSetupIntent(paymentMethodId,customerId);
        
        if (setupIntent.client_secret) {
          const authResult = await authenticateSetupIntent(setupIntent.client_secret,paymentMethodId);
         
          if (authResult.success === true) {
            //console.log('succesfull auth');
            submitBtn.disabled = false;
            const contactResult = await sendContactToDogDigital(formData);
            clearBallotForm();
            showSuccessMessage();
            dataLayerCTA('Enter Ballot', 'Enter ballot - Pay');
            
          }
        }
        // <<< End setup intent method
       
    } catch (error) {
        submitBtn.disabled = false;
        //console.log('Error creating stripe payment',error)
        return false;
    }
});

async function createPaymentMethod(customerName,customerEmail) {
    try {
      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
            name: customerName,
            email: customerEmail
        }
     });
     
     if (error) {
         let data = { success: false, 'message': error.message};
         //console.log('error creating payment method',error.message);
         return data;
     } else {
         const paymentMethodId = paymentMethod.id;
         let data = { success: true, 'paymentMethodId': paymentMethodId};
         return data;
    }
  } catch (error) {
      let data = { success: false, 'message': error.message};
      //console.error('Error creating PaymentMethod:', error);
      return data;
  }
    
}
async function createSetupIntent(paymentMethodId,customerId) {
  //console.log('1) setup  setupintent');
  const response = await fetch('/webhooks/stripe/create-setupintent.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      payment_method_id: paymentMethodId,
      customer_id: customerId
    }),
  });

  if (!response.ok) {
    throw new Error(`Error creating SetupIntent: ${response.statusText}`);
  }
  
  const data = await response.json();
  //console.log('2) setup  setupintent');
  return data;
}

async function createCustomer(customerName, customerEmail,shippingAddress,metaData,paymentMethodId) {
  //console.log('1) auth customer');
  const response = await fetch('/webhooks/stripe/create-customer.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      payment_method_id: paymentMethodId,
      name: customerName,
      email: customerEmail,
      shippingAddress: shippingAddress,
      meta_data: metaData
    }),
  });

  if (!response.ok) {
    //console.log(errorMsg);
     let errorMsg = response.statusText;
     let data = { success: false, 'message': errorMsg};
     return data;
  }
  
  const data = await response.json();
  
  if (data.success == true) {
    //console.log('2) auth customer');
    return { success: true, 'customerId': data.customerid};
  } else {
     return { success: false, 'message': data.message};
  }
}



    
    
async function authenticateSetupIntent(clientSecret,paymentMethodId) {
    //console.log('1) auth setupintent');
    
    const { setupIntent, error } = await stripe.confirmCardSetup(clientSecret, {
      payment_method: paymentMethodId,
    });

    if (error) {
      // Card setup failed
      return { success: false};
    } else if (setupIntent.status === 'succeeded') {
      // Card setup was successful
      return { success: true};
    }
}

function validateRequiredFields(form) {
  // Get all inputs with required class
  const formInputs = form.querySelectorAll('input.required');
 
  let errors = false;
  
  // Loop through the required elements
  for (const input of formInputs) {
    const inputType = input.type;
    
    switch (inputType) {
      case 'text':
        if (input.value.trim() === '') {
           errors = true;
           input.classList.add('error');
        } else {
           input.classList.remove('error');
        }
      break;
      case 'checkbox':
         if (!input.checked) {
           errors = true;
           input.classList.add('error');
         } else {
            input.classList.remove('error');
         }
      break;
      default:
        if (input.value.trim() === '') {
          errors = true;
          input.classList.add('error');
        } else {
           input.classList.remove('error');
        }
      break;
    }
  }
  
  if (errors) {
    return false;
  } else {
      return true;
  }
}

function validateDobField() {
    let day = dobDay.value;
    let month = dobMonth.value;
    let year = dobYear.value;

    month = Number(month) - 1; // 0-indexed month
    var d = new Date(year, month, day);
    
    if (d.getFullYear() == year && d.getMonth() == month && d.getDate() == day) {
        dobDay.classList.remove('error');
        dobMonth.classList.remove('error');
        dobYear.classList.remove('error');
        return true;
    }
    
    dobDay.classList.add('error');
    dobMonth.classList.add('error');
    dobYear.classList.add('error');
    return false;
}

function showSuccessMessage() {
  const successDiv = document.querySelector('.stripe-ballot-success-message');
  stripeAuBallotForm.classList.add('fade-out');
  
  stripeAuBallotForm.addEventListener("transitionend", function() {
      // After the transition is finished, hide the div
      stripeAuBallotForm.classList.add('hidden');
      successDiv.classList.remove('hidden');
      successDiv.scrollIntoView({ behavior: "smooth" });
      successDiv.classList.add('fade-in');
  });
  
}

function getDobFormatted() {
  let day = dobDay.value.trim();
  let month = dobMonth.value.trim();
  let year = dobYear.value.trim();
  let dob = day + '/' + month + '/' + year;
  
  return dob;
}

async function sendContactToDogDigital(formData) {
  
  //console.log('1) sending to DD ');
  const response = await fetch('/dotdigital/stripe_api/au-stripe-ballot.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      "field--first-name-text": formData['field--first-name-text'],
      "field--last-name-text": formData['field--last-name-text'],
      "field--day-text": formData['field--day-text'],
      "field--month-text": formData['field--month-text'],
      "field--year-text":  formData['field--year-text'],
      "field--email-text":  formData['field--email-text'],
      "field--checkbox1-text": formData['field--checkbox1-text'],
      "field--checkbox7-text": formData['field--checkbox7-text'],
      "field--zipcode-text": formData['field--zipcode-text']
    }),
  });

  if (!response.ok) {
    //console.error('Error sending to dot digital');
    //throw new Error(`Error creating SetupIntent: ${response.statusText}`);
  }
  
  const data = await response.json();
 
  //console.log('2) sent to dot digital');
  return data;
}

function getMetaDataForStripe() {
  let shoeSize = document.querySelector('#stripe-ballot-au-payment-form #ballotAuShoeSize').value.trim();
  let dob = getDobFormatted();
 
  const checkboxes = document.querySelectorAll('#stripe-ballot-au-payment-form input[type="checkbox"]');
  let metaData = {};
  
  metaData['shoe_size'] = shoeSize;
  metaData['date_of_birth'] = dob;
  
  for (const checkbox of checkboxes) {
    let key = checkbox.getAttribute('data-stripe-metatag-key');
    metaData[key] = checkbox.checked === true ? 'Yes' : 'No';
  }
  
  return metaData;
}


function getFormData(elements) {
   // Create an empty object to store form data
    const formData = {};

    // Get the form elements
    const formElements = event.target.elements;

    // Loop through form elements and add their values to the formData object
    for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];
        if (element.name && element.type == 'text' || element.type == 'email') {
            formData[element.name] = element.value.trim();
        }
    }
    
    formData['target_id'] = document.querySelector('#stripe-ballot-au-payment-form #content-form_submit_register_interest-field_target_id').value;
    formData['field--checkbox1-text'] =  document.querySelector('#stripe-ballot-au-payment-form #checkbox1--field').checked;
    formData['field--checkbox7-text'] =  document.querySelector('#stripe-ballot-au-payment-form #checkbox7--field').checked;

    return formData;
}

/* Clear the Stripe elements and the form fields */
function clearBallotForm() {
   cardElement.clear();
   addressElement.clear();
   stripeAuBallotForm.reset();
}

function dataLayerCTA(action, label) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'ctaClicks',
    'ga_event': {
      'category': 'Internal CTA Clicks',
      'action': action,
      'label': label,
      'value': 0,
      'nonInteraction': 0
    }
  });
}